<template>
  <popover
    :visible-ct="visible"
    :class="tClass"
    :top="top"
    :name="name"
    :pointer="pointer"
    :width="width"
    :event="event"
    :delay="delay"
    @show="value = $event.value"
    >{{ value }}</popover
  >
</template>
<script>
export default {
  name: 'Tooltip',
  props: {
    name: {
      type: String,
      default: 'tooltip',
    },
    event: {
      type: String,
      default: 'hover',
    },
    pointer: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [Number, String],
      default: 160,
    },
    top: {
      type: [Number, String],
    },
    delay: {
      type: Number,
      default: 0,
    },
    tClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      value: '',
    };
  },
};
</script>
